/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Regression_TestsInputs */

const en_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regression tests`)
};

const ar_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختبارات الانحدار`)
};

const bn_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`রিগ্রেশন টেস্ট`)
};

const de_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regressionstests`)
};

const es_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pruebas de regresión`)
};

const fr_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tests de régression`)
};

const pt_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testes de regressão`)
};

const zh_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`回归测试`)
};

const tr_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Regresyon testleri`)
};

const ru_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Регрессионные тесты`)
};

const pl_svchip_regression_tests = /** @type {(inputs: Svchip_Regression_TestsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Testy regresji`)
};

/**
* | output |
* | --- |
* | "Regression tests" |
*
* @param {Svchip_Regression_TestsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_regression_tests = /** @type {((inputs?: Svchip_Regression_TestsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Regression_TestsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_regression_tests(inputs)
	if (locale === "bn") return bn_svchip_regression_tests(inputs)
	if (locale === "de") return de_svchip_regression_tests(inputs)
	if (locale === "es") return es_svchip_regression_tests(inputs)
	if (locale === "fr") return fr_svchip_regression_tests(inputs)
	if (locale === "pt") return pt_svchip_regression_tests(inputs)
	if (locale === "zh") return zh_svchip_regression_tests(inputs)
	if (locale === "tr") return tr_svchip_regression_tests(inputs)
	if (locale === "ru") return ru_svchip_regression_tests(inputs)
	if (locale === "pl") return pl_svchip_regression_tests(inputs)
	return en_svchip_regression_tests(inputs)
});